/**
 * API DIFFERENCES vs ../separator.tsx (shadcn):
 * - No decorative prop (always decorative in base-ui)
 * - Vertical: self-stretch when no height class vs h-full always
 */
import { Separator as SeparatorPrimitive } from '@base-ui/react/separator'
import { cn } from '../lib/utils'

function Separator({
  className,
  children,
  orientation = 'horizontal',
  ...props
}: SeparatorPrimitive.Props) {
  const hasText = children !== undefined && children !== null

  return (
    <SeparatorPrimitive
      className={cn(
        hasText
          ? 'before:bg-separator after:bg-separator grid w-full shrink-0 grid-cols-[1fr_auto_1fr] items-center gap-4 before:h-px before:rounded-full after:h-px after:rounded-full data-[orientation=vertical]:hidden'
          : "bg-separator shrink-0 rounded-full data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px data-[orientation=vertical]:not-[[class^='h-']]:not-[[class*='_h-']]:self-stretch",
        className,
      )}
      data-slot="separator"
      orientation={orientation}
      {...props}
    >
      {children}
    </SeparatorPrimitive>
  )
}

export { Separator }
